// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import CaptureImageSeries from './data'

export default function CaptureImageSeriesFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/CaptureImageSeries">
      <CaptureImageSeries {...props}>
        {children}
      </CaptureImageSeries>
    </Flow>
  )
}
